export interface ExerciseStep {
    title: string;
    description: string;
    instruction?: string;
}

export enum ExerciseType {
    STEP_BY_STEP = 'step-by-step',
    INTERACTIVE = 'interactive'
}

export interface Exercise {
    id: string;
    type?: ExerciseType; // Default is ExerciseType.STEP_BY_STEP
    title: string;
    description: string;
    shortDescription: string;
    duration: string;
    imageUrl?: string;
    completionMessage?: string;
    steps: ExerciseStep[];
    breathingConfig?: {
        inhaleDuration: number; // in seconds
        holdDuration?: number;   // in seconds
        exhaleDuration: number; // in seconds
        holdAfterExhale?: number; // in seconds (for box breathing)
        cycles: number; // total cycles recommended
        visualType?: 'circle' | 'slope';
    };
}

export const exercises: Exercise[] = [
    {
        id: 'grounding-54321',
        type: ExerciseType.STEP_BY_STEP,
        title: 'Упражнение на заземление «5–4–3–2–1»',
        shortDescription: 'Техника для быстрого снятия стресса и возвращения в настоящий момент через пять органов чувств.',
        description: 'Это простое и эффективное упражнение помогает вернуться в настоящий момент, снизить уровень тревоги и восстановить ощущение опоры. Оно может быть полезно при эмоциональном напряжении, тревоге, ощущении перегруженности или потере концентрации.',
        duration: '3-5 минут',
        imageUrl: '/images/character-grounding.svg',
        completionMessage: 'Даже короткая пауза имеет значение.\nВы дали себе возможность немного восстановиться.',
        steps: [
            {
                title: 'Зрение — 5 вещей',
                description: 'Посмотрите вокруг и назовите пять предметов, которые вы видите.',
                instruction: 'Обратите внимание на их цвет, форму, размер, расположение в пространстве. Это могут быть любые, самые обычные вещи.'
            },
            {
                title: 'Слух — 4 звука',
                description: 'Прислушайтесь и отметьте четыре звука, которые вы можете услышать.',
                instruction: 'Это могут быть звуки вокруг вас или более тихие, фоновые — например, дыхание или отдалённый шум.'
            },
            {
                title: 'Осязание — 3 ощущения',
                description: 'С помощью рук прикоснитесь к трём разным поверхностям и осознанно отметьте ощущения.',
                instruction: 'Обратите внимание на текстуру, температуру, твёрдость или мягкость предметов.'
            },
            {
                title: 'Обоняние — 2 запаха',
                description: 'Постарайтесь уловить два запаха в окружающем пространстве.',
                instruction: 'Если запахи неочевидны, можно обратить внимание на запах одежды, кожи или воздуха.'
            },
            {
                title: 'Вкус — 1 ощущение',
                description: 'Обратите внимание на одно вкусовое ощущение.',
                instruction: 'При желании можно взять что-нибудь и попробовать: кусочек шоколада, конфету, яблоко или сделать глоток чая или воды. Постарайтесь заметить вкус, температуру и ощущения во рту.'
            }
        ]
    },
    {
        id: 'breathing-relaxation',
        type: ExerciseType.INTERACTIVE,
        title: 'Дыхание для успокоения',
        shortDescription: 'Успокаивающее дыхание.',
        description: 'Это упражнение помогает расслабиться перед сном, замедляя ритм сердца и успокаивая мысли. Следуйте за движением шарика: вдох — подъем, выдох — спуск.',
        duration: '3 минуты',
        imageUrl: '/images/character-relaxation.svg',
        completionMessage: 'Вы отлично справились!',
        steps: [
            {
                title: 'Инструкция',
                description: 'Следуйте за ритмом дыхания на экране.',
                instruction: '• Вдох: шарик поднимается вверх\n• Выдох: шарик опускается вниз\n• Старайтесь дышать животом, расслабленно.'
            }
        ],
        breathingConfig: {
            inhaleDuration: 4,
            exhaleDuration: 6,
            cycles: 15,
            visualType: 'slope'
        }
    },
    {
        id: 'breathing-4-7-8',
        type: ExerciseType.INTERACTIVE,
        title: 'Дыхание «4–7–8»',
        shortDescription: 'Эффективная техника для быстрого успокоения и снижения уровня тревоги.',
        description: 'Техника «4–7–8» помогает переключить нервную систему из состояния стресса в расслабление. Она действует как естественное успокоительное для нервной системы.',
        duration: '2-3 минуты',
        imageUrl: '/images/character-breathing.svg', // Placeholder, using generic if not found
        completionMessage: 'Отлично!\nВы восстановили естественный ритм дыхания.',
        steps: [
            {
                title: 'Подготовка',
                description: 'Сядьте удобно, выпрямите спину. Расслабьте плечи и лицо. Кончик языка поместите за верхними передними зубами.',
            },
            {
                title: 'Техника',
                description: 'Выполняйте цикл дыхания, следуя анимации:',
                instruction: '• Вдох носом (4 счета)\n• Задержка дыхания (7 счетов)\n• Шумный выдох через рот (8 счетов)'
            }
        ],
        breathingConfig: {
            inhaleDuration: 4,
            holdDuration: 7,
            exhaleDuration: 8,
            cycles: 4
        }
    }
];
